import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import { QRCodeCanvas } from "qrcode.react";
import React from "react";

const TableProductReceipt = ({ products, columns }) => {
  const formatCellValue = (key, value) => {
    if (value == null || value === "") return "-";

    // เช็คถ้า key มีคำว่า "price", "total_price"
    if (/price|total_price/i.test(key)) {
      return `${Number(value).toLocaleString()} บาท`;
    }

    if (/amount/i.test(key)) {
      return Number(value) ?? 1;
    }

    // ถ้า key คือ detail
    if (key === "detail") {
      return `(${value})`;
    }

    return value;
  };

  console.log({ products });
  return (
    <TableContainer
      component={Paper}
      sx={{
        mt: 2,
        border: "2px solid #00BB9F",
        borderRadius: "20px",
        width: "100%", // Adjust this as per your needs
        paddingX: 1,
      }}
    >
      <Table sx={{ width: "100%" }}>
        <TableHead
          sx={{
            "& .MuiTableCell-root": {
              // Targets all TableCell components within TableBody
              padding: "5px", // Adjust padding as needed
            },
          }}
        >
          <TableRow>
            {columns.map((column, index) => (
              <TableCell key={column?.key || index}>
                <Typography>{column?.label}</Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody
          sx={{
            "& .MuiTableCell-root": {
              // Targets all TableCell components within TableBody
              padding: "5px", // Adjust padding as needed
              verticalAlign: "top",
              borderBottom: "none",
            },
          }}
        >
          {products?.map((product, index) => (
            <TableRow key={product.product_id}>
              {columns.map((column) =>
                column?.key === "index" ? (
                  <TableCell key={column.key} sx={{ display: "flex" }}>
                    <Typography sx={{ fontWeight: "bold", mr: 1 }}>
                      {index + 1}.
                    </Typography>
                    {product.product_code ? (
                      <QRCodeCanvas
                        value={product.product_code} // ดึงค่าจาก formik และใช้ค่าที่ว่างเป็นค่า default ถ้าไม่พบ
                        size={40} // ขนาดของ QR Code
                        bgColor={"#ffffff"} // สีพื้นหลัง
                        fgColor={"#000000"} // สีของ QR Code
                        level={"H"} // ระดับการกู้คืนข้อมูล (L, M, Q, H)
                      />
                    ) : (
                      <div
                        style={{
                          marginLeft: "10px",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "40px",
                          height: "40px",
                          backgroundColor: "#e0e0e0",
                        }}
                      >
                        QR
                      </div>
                    )}
                  </TableCell>
                ) : (
                  <TableCell key={column.key}>
                    {column?.render ? (
                      column.render(product[column.key], product)
                    ) : (
                      <Typography sx={{ fontWeight: "bold" }}>
                        {formatCellValue(column.key, product[column.key])}
                      </Typography>
                    )}
                  </TableCell>
                )
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableProductReceipt;
